module.exports = __webpack_public_path__ + "img/RO.755a3ebc.svg";